import React, { Component, Fragment } from 'react';
import styled, { css } from 'styled-components';
import _ from 'lodash';

import FormError from 'common/components/styleguide/form/_helpers/FormError';
import Input from 'common/components/styleguide/form/Input';
import Icon from 'common/components/styleguide/Icon';

const DEFAULT_NUMSTEPPER_BUTTON_FONT_SIZE = '12px';
const DEFAULT_NUMSTEPPER_BUTTON_COLOR = '#000';
const DEFAULT_NUMSTEPPER_BUTTON_BACKGROUND_HOVER = '#efefef';

const S = {};
S.GroupWrapper = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
`;

S.Wrapper = styled.div`
  position: relative;
  display: flex;
`;

S.RealInputNumber = styled.input`
  display: none;
`;

S.Button = styled.button`
  padding: 0;
  border: none;

  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  cursor: pointer;
  background-color: ${({ theme, customStyle }) =>
    _.get(
      customStyle,
      'backgroundColor',
      _.get(
        theme,
        'numstepper.backgroundColor',
        'white'
      )
    )};
`;

S.ButtonPrev = styled(S.Button)`
  font-size: ${({ theme, customStyle }) =>
    _.get(
      customStyle,
      'prev.fontSize',
      _.get(
        theme,
        'numstepper.prev.fontSize',
        DEFAULT_NUMSTEPPER_BUTTON_FONT_SIZE
      )
    )};
  font-weight: ${({ theme, customStyle }) =>
    _.get(
      customStyle,
      'prev.fontWeight',
      _.get(
        theme,
        'numstepper.prev.fontWeight',
        'normal'
      )
    )};
  height: ${({ theme, customStyle }) =>
    _.get(customStyle, 'height', _.get(theme, 'numstepper.height'))};
  width: ${({ theme, customStyle }) =>
    _.get(customStyle, 'prev.width', _.get(theme, 'numstepper.prev.width'))};
  color: ${({ theme, customStyle }) =>
    _.get(
      customStyle,
      'prev.color',
      _.get(theme, 'numstepper.prev.color', DEFAULT_NUMSTEPPER_BUTTON_COLOR)
    )};
  border-color: ${({ theme, customStyle }) =>
    _.get(
      customStyle,
      'prev.border.color',
      _.get(theme, 'numstepper.prev.border.color')
    )};
  border-style: ${({ theme, customStyle }) =>
    _.get(
      customStyle,
      'prev.border.style',
      _.get(theme, 'numstepper.prev.border.style')
    )};
  border-width: ${({ theme, customStyle }) =>
    _.get(
      customStyle,
      'prev.border.width',
      _.get(theme, 'numstepper.prev.border.width')
    )};
  border-radius: ${({ theme, customStyle }) =>
    _.get(
      customStyle,
      'prev.border.radius',
      _.get(theme, 'numstepper.prev.border.radius')
    )};
  &:hover {
    color: ${({ theme, customStyle }) =>
      _.get(
        customStyle,
        'prev.hover.color',
        _.get(
          theme,
          'numstepper.prev.hover.color',
          DEFAULT_NUMSTEPPER_BUTTON_COLOR
        )
      )};
    background: ${({ theme, customStyle }) =>
      _.get(
        customStyle,
        'prev.hover.background',
        _.get(
          theme,
          'numstepper.prev.hover.background',
          DEFAULT_NUMSTEPPER_BUTTON_BACKGROUND_HOVER
        )
      )};
  }
  ${({ theme }) => css`
    ${_.get(theme, 'numstepper.prev.customStyle', '')}
  `}
`;
S.ButtonNext = styled(S.Button)`
  font-size: ${({ theme, customStyle }) =>
    _.get(
      customStyle,
      'next.fontSize',
      _.get(
        theme,
        'numstepper.next.fontSize',
        DEFAULT_NUMSTEPPER_BUTTON_FONT_SIZE
      )
    )};
  font-weight: ${({ theme, customStyle }) =>
    _.get(
      customStyle,
      'next.fontWeight',
      _.get(
        theme,
        'numstepper.next.fontWeight',
        'normal'
      )
    )};
  height: ${({ theme, customStyle }) =>
    _.get(customStyle, 'height', _.get(theme, 'numstepper.height'))};
  width: ${({ theme, customStyle }) =>
    _.get(customStyle, 'next.width', _.get(theme, 'numstepper.next.width'))};
  color: ${({ theme, customStyle }) =>
    _.get(
      customStyle,
      'next.color',
      _.get(theme, 'numstepper.next.color', DEFAULT_NUMSTEPPER_BUTTON_COLOR)
    )};
  border-color: ${({ theme, customStyle }) =>
    _.get(
      customStyle,
      'next.border.color',
      _.get(theme, 'numstepper.next.border.color')
    )};
  border-style: ${({ theme, customStyle }) =>
    _.get(
      customStyle,
      'next.border.style',
      _.get(theme, 'numstepper.next.border.style')
    )};
  border-width: ${({ theme, customStyle }) =>
    _.get(
      customStyle,
      'next.border.width',
      _.get(theme, 'numstepper.next.border.width')
    )};
  border-radius: ${({ theme, customStyle }) =>
    _.get(
      customStyle,
      'next.border.radius',
      _.get(theme, 'numstepper.next.border.radius')
    )};
  &:hover {
    color: ${({ theme, customStyle }) =>
      _.get(
        customStyle,
        'numstepper.next.hover.color',
        _.get(
          theme,
          'numstepper.next.hover.color',
          DEFAULT_NUMSTEPPER_BUTTON_COLOR
        )
      )};
    background: ${({ theme, customStyle }) =>
      _.get(
        customStyle,
        'numstepper.next.hover.background',
        _.get(
          theme,
          'numstepper.next.hover.background',
          DEFAULT_NUMSTEPPER_BUTTON_BACKGROUND_HOVER
        )
      )};
  }
  ${({ theme }) => css`
    ${_.get(theme, 'numstepper.next.customStyle', '')}
  `}
`;

S.Input = styled(Input)`
  text-align: center;
  height: ${({ theme, customStyle }) =>
    _.get(customStyle, 'height', _.get(theme, 'numstepper.height'))};
  width: ${({ theme, customStyle }) =>
    _.get(customStyle, 'input.width', _.get(theme, 'numstepper.input.width'))};
  padding: 0;
  color: ${({ theme, customStyle }) =>
    _.get(customStyle, 'input.color', _.get(theme, 'numstepper.input.color'))};
  background: ${({ theme, customStyle }) =>
    _.get(
      customStyle,
      'input.background',
      _.get(theme, 'numstepper.input.background')
    )};
  border-color: ${({ theme, customStyle }) =>
    _.get(
      customStyle,
      'input.border.color',
      _.get(theme, 'numstepper.input.border.color')
    )};
  border-style: ${({ theme, customStyle }) =>
    _.get(
      customStyle,
      'input.border.style',
      _.get(theme, 'numstepper.input.border.style')
    )};
  border-width: ${({ theme, customStyle }) =>
    _.get(
      customStyle,
      'input.border.width',
      _.get(theme, 'numstepper.input.border.width')
    )};
  border-radius: ${({ theme, customStyle }) =>
    _.get(
      customStyle,
      'input.border.radius',
      _.get(theme, 'numstepper.input.border.radius')
    )};
  ${({ theme }) => css`
    ${_.get(theme, 'numstepper.input.customStyle', '')}
  `}
`;

S.FormError = styled(FormError)`
  width: 100%;
`;

class NumStepper extends Component {
  state = {
    value: 0
  };
  incrementValue = () => {
    const { value } = this.state;
    const { max = false, onChange } = this.props;
    let newValue = value + 1;
    if (max !== false && newValue > max) return;
    this.setState({ value: newValue });
    this.setFormikField(newValue);
    if (onChange) {
      onChange(newValue);
    }
  };
  decrementValue = () => {
    const { value } = this.state;
    const { min = 0, onChange } = this.props;
    let newValue = value - 1;
    if (newValue < min) return;
    this.setState({ value: newValue });
    this.setFormikField(newValue);
    if (onChange) {
      onChange(newValue);
    }
  };
  handleOnInputBlur = e => {
    let newValue = _.toNumber(e.target.value);
    const { max, min, onChange } = this.props;
    if (max && newValue > max) {
      newValue = max;
    }
    if (min && newValue < min) {
      newValue = min;
    }
    this.setState({ value: newValue });
    this.setFormikField(newValue);
    if (onChange) {
      onChange(newValue);
    }
  };
  handleOnInputChange = e => {
    this.setState({
      value: e.target.value
    });
  };
  setFormikField = value => {
    const { name, setFieldValue, setFieldTouched } = this.props;
    if (name && setFieldValue) {
      setFieldValue(name, value);
    }
    if (name && setFieldTouched) {
      setFieldTouched(name);
    }
  };
  componentDidMount() {
    const { startValue, setValue } = this.props;
    if (setValue) {
      this.setState({ value: setValue });
      return;
    }
    if (startValue) {
      this.setState({ value: startValue });
    }
  }
  render() {
    const {
      name,
      className,
      prevText,
      nextText,
      prevIconClassName = 'nc-ic_arrow_drop_down_18px',
      nextIconClassName = 'nc-ic_arrow_drop_up_18px',
      customStyle,
      isDisabled = false,
      error
    } = this.props;
    const { value } = this.state;
    return (
      <S.GroupWrapper>
        <S.Wrapper className={className}>
          {!isDisabled ? (
            <S.ButtonPrev
              type="button"
              onClick={this.decrementValue}
              customStyle={customStyle}
            >
              {prevText ? (
                prevText
              ) : (
                <Icon className={prevIconClassName} />
              )}
            </S.ButtonPrev>
          ) : (
            ''
          )}
          <S.Input
            disabled={isDisabled}
            type="text"
            name={name}
            onBlur={this.handleOnInputBlur}
            onChange={this.handleOnInputChange}
            value={value}
            customStyle={customStyle}
          />
          {!isDisabled ? (
            <S.ButtonNext
              type="button"
              onClick={this.incrementValue}
              customStyle={customStyle}
            >
              {nextText ? (
                nextText
              ) : (
                <Icon className={nextIconClassName} />
              )}
            </S.ButtonNext>
          ) : (
            ''
          )}
          <S.RealInputNumber type="number" value={value} readOnly />
        </S.Wrapper>
        {error ? <S.FormError>{error}</S.FormError> : null}
      </S.GroupWrapper>
    );
  }
}

export default NumStepper;
